// @ts-nocheck
"use client";

import Script from "next/script";

export default function ChatSupport() {
  return <Script id="jivoChat" src="//code.jivo.ru/widget/4eyCUPm8Fg" async />;
}
